import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media, pxToRem } from '$util/theme';
import { Title } from '@/components/atoms/Title';

const H1 = styled((props) => <Title size="xl" h={1} {...props} />)`
  ${media.down('sm')} {
    font-size: ${pxToRem(32)};
  }
`;

const H2 = styled((props) => <Title size="md" h={2} {...props} />)`
  ${media.down('sm')} {
    font-size: ${pxToRem(22)};
  }
`;

export default function MainTitle({ children, subTitle }) {
  return (
    <>
      <H1>{children}</H1>
      {subTitle && <H2>{subTitle}</H2>}
    </>
  );
}

MainTitle.propTypes = {
  children: PropTypes.node.isRequired,
  subTitle: PropTypes.node,
};

MainTitle.defaultProps = {
  subTitle: null,
};
